(() => {
  if (window.mathersAutoCart) return;
  window.mathersAutoCart = true;
  let timer, busy = false;
  async function update(form) {
    if (busy || !form.isConnected || !form.reportValidity()) return;
    busy = true;
    const status = form.querySelector('[data-cart-update-status]');
    const updates = {};
    form.querySelectorAll('[data-line-key]').forEach(input => { updates[input.dataset.lineKey] = Number(input.value); });
    const sectionId = form.dataset.sectionId;
    const body = JSON.stringify({updates, sections: [sectionId], sections_url: location.pathname});
    const controls = [...form.querySelectorAll('button, input')];
    const disabled = controls.map(el => el.disabled);
    controls.forEach(el => el.disabled = true);
    form.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Updating cart…';
    try {
      const endpoint = new URL(form.action, location.origin);
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '/update.js';
      const response = await fetch(endpoint, {method: 'POST', body, credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update cart.');
      const html = data.sections && data.sections[sectionId];
      const doc = html ? new DOMParser().parseFromString(html, 'text/html') : null;
      const cart = doc && doc.querySelector('.cart-page');
      if (!cart) { location.reload(); return; }
      document.querySelector('.cart-page').replaceWith(cart);
      document.querySelectorAll('.cart-count').forEach(el => el.textContent = data.item_count);
      document.querySelectorAll('.cart-link').forEach(el => el.setAttribute('aria-label', `Cart, ${data.item_count} items`));
      document.dispatchEvent(new Event('shopify:section:load'));
      const updatedStatus = document.querySelector('[data-cart-update-status]');
      if (updatedStatus) updatedStatus.textContent = 'Cart updated.';
    } catch (error) {
      if (status) status.textContent = error.message || 'Connection error. Please reload the cart.';
    } finally {
      busy = false;
      if (form.isConnected) {
        controls.forEach((el, i) => el.disabled = disabled[i]);
        form.removeAttribute('aria-busy');
      }
    }
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('#cart-form input[name="updates[]"]')) return;
    clearTimeout(timer);
    const form = event.target.form;
    timer = setTimeout(() => update(form), 250);
  });
  document.addEventListener('submit', event => {
    if (event.target.id !== 'cart-form') return;
    if (busy) { event.preventDefault(); return; }
    clearTimeout(timer);
  });
})();
